function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M48.495 31.43c1.717-9.99-9.466-8.521-9.466-8.521L36.23 39.913s10.545 1.65 12.265-8.483zm7.46.134c-1.284 7.761-7.518 15.484-17.485 15.484H27.901l5.13-31.07h10.56c9.937 0 13.636 7.764 12.364 15.586zM31.592 16.045C26.381 51.122 9.203 47.908 9.203 47.908l.97-7.422c11.973.146 14.009-24.44 14.009-24.44h7.41zM64 32C64 14.33 49.67 0 31.999 0 14.324 0 0 14.329 0 32s14.324 32 31.999 32C49.67 64 64 49.671 64 32z",
  fill: "#1A1A1A"
});

function SvgJdLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgJdLogoinline;